import { Button, Text, HStack, VStack } from '@genial/components';
import { BoxRadius, Spacing, Typography } from '@genial/design-tokens';
import { Utils } from '@genial/utils';
import { Box } from 'native-base';
import React, { useCallback } from 'react';
import { useRecoilState } from 'recoil';

import { newWithdrawalAtom } from '../../../../../../../../store/customerDetail/withdrawal/atom';
import { TokenNumberInput } from '../../../../../../../SignIn/components/TokenNumberInput';
import { NewWithdrawalTypes } from '../../types';

export const SummaryAndTokenValidation: React.FC<NewWithdrawalTypes.StepProps> = ({ onFinish }) => {
  const [withdrawalState, setWithdrawalState] = useRecoilState(newWithdrawalAtom);
  const isValid = withdrawalState.token.length === 6;

  const handleChangeToken = useCallback(
    (text: string) => {
      setWithdrawalState((state) => ({ ...state, token: text }));
    },
    [setWithdrawalState]
  );

  const handleFinish = useCallback(() => {
    onFinish();
  }, [onFinish]);

  return (
    <VStack space={Spacing['stack.xxxs']}>
      <VStack
        backgroundColor={Utils.ColorToken.WithOpacity('brand.tertiary.lightest', 0.7)}
        space={Spacing['stack.nano']}
        paddingX={Spacing['inset.sm']}
        paddingY={Spacing['inset.xs']}
        borderRadius={BoxRadius.sm}>
        <HStack justifyContent="space-between">
          <Text>Valor de saque:</Text>
          <Text variant="semibold">{Utils.Mask.Money(withdrawalState.value)}</Text>
        </HStack>
        <HStack justifyContent="space-between">
          <Text>Data de solicitação:</Text>
          <Text variant="semibold">
            {Utils.Mask.DateFormat(withdrawalState.requestDate, 'dd/MM/yyyy')}
          </Text>
        </HStack>
        <HStack justifyContent="space-between">
          <Text>Data para saque:</Text>
          <Text variant="semibold">
            {Utils.Mask.DateFormat(withdrawalState.withdrawalDate, 'dd/MM/yyyy')}
          </Text>
        </HStack>
      </VStack>
      <Text fontSize={Typography['fontsize.lg']} variant="semibold">
        Validação de acesso
      </Text>
      <VStack space={Spacing['stack.nano']}>
        <Text fontSize={Typography['fontsize.md']} variant="semibold">
          Precisamos validar o token para sua segurança
        </Text>
        <Text>
          No seu app de autenticação, procure por ‘Genial Investimentos’ e informe os números
          gerados.
        </Text>
      </VStack>
      <TokenNumberInput value={withdrawalState.token} onChangeText={handleChangeToken} />
      <Text fontSize={Typography['fontsize.lg']} variant="semibold">
        Ainda não tem o token habilitado?
      </Text>
      <Text>
        Entre no portal e clique no ícone do seu usuário, localizado no canto superior direito. Em
        seguida, selecione a opção “Ver Perfil” e depois clique em “Habilitar Token”.
      </Text>
      <Box justifyContent="flex-end">
        <Button disabled={!isValid} onPress={handleFinish}>
          Confirmar
        </Button>
      </Box>
    </VStack>
  );
};
